import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';
import { parseUserActive } from '../../../Utils/parseUserActive';

const displaysWithoutSchedules = {
  name: 'displaysWithoutSchedules',
  state: {
    data: [],
    loading: false,
    error: '',
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        data: [],
      };
    },

    getReceived(state, payload) {
      const normalizeScreens = (item) => {
        const rawScreens = Array.isArray(item?.screens) && item?.screens;

        const normalizedFromArray = rawScreens.map((s) => ({
          display_type: item?.display_type,
          orientation: s?.orientation,
          resolution: s?.resolutions,
          led_width: item?.led_width,
          led_height: item?.led_height,
        }));

        if (normalizedFromArray.length > 0) {
          return normalizedFromArray;
        }

        const rootDisplayType = item?.display_type || item?.displayType || null;
        const rootOrientation = item?.orientation || item?.orientations || 'Landscape';
        const rootResolution = item?.resolution || item?.resolutions || null;
        const rootLedWidth = item?.led_width || item?.ledWidth || null;
        const rootLedHeight = item?.led_height || item?.ledHeight || null;

        if (rootDisplayType || rootLedWidth || rootLedHeight || rootResolution) {
          return [
            {
              display_type: rootDisplayType,
              orientation: rootOrientation,
              resolution: rootResolution,
              led_width: rootLedWidth,
              led_height: rootLedHeight,
            },
          ];
        }

        return [];
      };

      const displayData = payload.data
        .filter((item) => parseUserActive(item?.active))
        .map((item) => ({
          id: item.id,
          name: item.name,
          active: true,
          screens: normalizeScreens(item),
        }));
      return {
        ...state,
        data: displayData,
        loading: false,
        error: '',
      };
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async fetchDisplaysWithoutSchedules({ isDefault }) {
      try {
        this.getRequested();
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const orgId = userInfo?.org_id;
        const url = `savvy/displays/lookup/${orgId}?isDefault=${isDefault}`;
        const response = await http.get(url);
        if (response && response.data) {
          this.getReceived({
            data: response.data.data,
          });
        }
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
    async getDisplays() {
      try {
        this.getRequested();
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const orgId = userInfo?.org_id;
        const url = `savvy/displays/lookupDisplays/${orgId}`;
        const response = await http.get(url);
        if (response && response.data) {
          this.getReceived({
            data: response.data.data,
          });
        }
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default displaysWithoutSchedules;


